'use client'

import { useMemo } from 'react'
import { useSession } from 'next-auth/react'

/**
 * The signed-in user's roles, as an array that keeps the same identity until
 * the roles themselves change.
 *
 * next-auth hands out a new session object (and a new `roles` array) every
 * time it refetches the session. A page whose data loader depended on
 * `session` or `session.roles` therefore reloaded, spinner and all, on every
 * refetch, wiping whatever the user had open (RELI UAT: "the system refreshes
 * every few seconds and we lose our work"). Depend on this instead.
 */
export function useStableRoles(): string[] {
  const { data: session } = useSession()
  const key = ((session?.roles as string[] | undefined) ?? []).join('\n')
  return useMemo(() => (key ? key.split('\n') : []), [key])
}
